import React, { Component } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import {reports} from "../../../components/Report.js";
export default class Billings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_start_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      filter_end_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      filter_warehouse_id: "",
      filter_payment_type: "",
      filter_status: "รอชำระ,รอสั่งสินค้า,คืนสินค้า,ใบแจ้งหนี้,เสร็จสิ้น",

      data: [],
      count: 10,
      data_warehouse: [],

      id: "",
      uid: "",
      bank_name: "",
      account_number: "",
      account_name: "",
    };
    this.tableRef = React.createRef();
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const {
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_payment_type,
      filter_status,
    } = this.state;
    let data, count, data_warehouse;
    loading(true);
    let [result, result_warehouse] = await Promise.all([
      GET("admin/sales/report", {
        page: 0,
        page_size: 10000,
        data_search: filter_search,
        start_date: filter_start_date,
        end_date: filter_end_date,
        warehouse_id: filter_warehouse_id,
        payment_type: filter_payment_type,
        status_code: filter_status,
        withdrawal_type: "ขายหน้าร้าน,รอสั่งสินค้า",
      }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
  data = result.data;
  // count = result.count;

  // let batchSize = 30;
  // let array = [];

  // for (let i = 0; i < data.length; i += batchSize) {
  //   // หั่นงานเป็นก้อน ๆ ละ 50
  //   const batch = data.slice(i, i + batchSize);

  //   // ยิง API ของ batch นี้พร้อมกัน
  //   const result_product = await Promise.all(
  //     batch.map((e) => GET("admin/sales/list", { uid: e.uid }))
  //   );

  //   // รวมผลลัพธ์ลง array
  //   for (let item of result_product) {
  //     array.push({
  //       ...item.data,
  //     });
  //   }
  // }

  // data = array;
  console.log("data:", data)
}
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }
    this.setState({
      data,
      count,
      data_warehouse,
    });
    loading(false);
  };
getTableArrayWithSpan = () => {
  const table = this.tableRef.current;
  if (!table) return [];

  const rows = Array.from(table.querySelectorAll("tbody tr"));
  const matrix = [];
  const spanMap = {}; // เก็บตำแหน่งที่ถูกจองจาก rowspan

  rows.forEach((tr, rowIndex) => {
    matrix[rowIndex] = matrix[rowIndex] || [];
    let colIndex = 0;

    // ข้ามช่องที่ถูก rowspan จากแถวก่อน (ใส่ค่าว่าง)
    while (spanMap[`${rowIndex},${colIndex}`]) {
      matrix[rowIndex][colIndex] = "";
      delete spanMap[`${rowIndex},${colIndex}`];
      colIndex++;
    }

    Array.from(tr.children).forEach((cell) => {
      const text = cell.innerText.trim();
      const colspan = Number(cell.getAttribute("colspan") || 1);
      const rowspan = Number(cell.getAttribute("rowspan") || 1);

      for (let r = 0; r < rowspan; r++) {
        for (let c = 0; c < colspan; c++) {
          const targetRow = rowIndex + r;
          const targetCol = colIndex + c;

          matrix[targetRow] = matrix[targetRow] || [];

          // ตำแหน่งจริง ใส่ text / ที่เหลือใส่ ""
          matrix[targetRow][targetCol] =
            r === 0 && c === 0 ? text : "*";

          // ถ้า rowspan > 1 จองช่องแถวถัดไป
          if (r > 0) {
            spanMap[`${targetRow},${targetCol}`] = true;
          }
        }
      }

      colIndex += colspan;

      // ข้ามช่องที่ถูกจองไว้
      while (spanMap[`${rowIndex},${colIndex}`]) {
        matrix[rowIndex][colIndex] = "";
        delete spanMap[`${rowIndex},${colIndex}`];
        colIndex++;
      }
    });
  });

  return matrix;
} 
colSpan = (item, index) => {
  // ช่องนี้เป็นตัวที่โดน merge อยู่แล้ว
  if (item[index] === "*") return 0;

  let span = 1;

  for (let i = index + 1; i < item.length; i++) {
    if (item[i] === "*") {
      span++;
    } else {
      break;
    }
  }

  return span || "";
};
      ExportPDF = async () => {
        const data_list = this.getTableArrayWithSpan();
        let footer = false;
        const obj = {
              table: {
                headerRows: 0,
                widths: ["auto",100,45,45,45,50,65,45],
                body: [
                  [
                    { text: " ", fontSize: 2, border: [0,0,0,1] },
                    { text: " ", fontSize: 2, border: [0,0,0,1] },
                    { text: " ", fontSize: 2, border: [0,0,0,1] },
                    { text: " ", fontSize: 2, border: [0,0,0,1] },
                    { text: " ", fontSize: 2, border: [0,0,0,1] },
                    { text: " ", fontSize: 2, border: [0,0,0,1] },
                    { text: " ", fontSize: 2, border: [0,0,0,1] },
                    { text: " ", fontSize: 2, border: [0,0,0,1] },
                  ],
                  ...data_list.map((item, index) => {
                    let border = [1, 0, 1, 0];let color = "#ffffff";
                    if(index === data_list.length - 1){
                      border = [1, 0, 1, 1];
                    }
                    if(item[0]){
                      footer = false;
                      border = !item[0].includes("ลำดับ") ? [1, 0, 1, 0]: [1, 1, 1, 1];
                      color = data_list[index+1].includes("ลำดับ") ? "#d8d8d8": "#ffffff";
                      return [
                           item[0] === "*" ? "" : { text: item[0], alignment: "center", colSpan: this.colSpan(item, 0), fillColor: color, border: [1, border[1], border[2], border[3]] },
                        item[1] === "*" ? "" : { text: item[1], alignment: "left", colSpan: this.colSpan(item, 1), fillColor: color, border },
                        item[2] === "*" ? "" : { text: item[2], alignment: "center", colSpan: this.colSpan(item, 2), fillColor: color, border },
                        item[3] === "*" ? "" : { text: item[3], alignment: "center", colSpan: this.colSpan(item, 3), fillColor: color, border },
                        item[4] === "*" ? "" : { text: item[4], alignment: "center", colSpan: this.colSpan(item, 4), fillColor: color, border },
                        item[5] === "*" ? "" : { text: item[5], alignment: "center", colSpan: this.colSpan(item, 5), fillColor: color, border },
                        item[6] === "*" ? "" : { text: item[6], alignment: "center", colSpan: this.colSpan(item, 6), fillColor: color, border },
                        item[7] === "*" ? "" : { text: item[7], alignment: "right", colSpan: this.colSpan(item, 7), fillColor: color, border: [border[0], border[1], 1, border[3]] },
                        ]
                    }
                    else{
                       border = [1, 0, 1, 0];
                   if(!footer){
                     border = [1, 1, 1, 1];
                   }
                   if(item[6] === "ยอดรวมรายการขาย"){
                    border = [1, 1, 1, 1];
                   }
                   footer = true;
                      return [
                        { text: item[0], alignment: item[3] === "รวมเป็นเงิน" || item[6] === "ยอดรวมรายการขาย" ? "center":"right", border, fillColor: item[3] === "รวมเป็นเงิน" || item[6] === "ยอดรวมรายการขาย" ? "#f1f1f1" : "#ffffff" },
                        { text: item[1], alignment: item[3] === "รวมเป็นเงิน" || item[6] === "ยอดรวมรายการขาย" ? "center":"right", border, fillColor: item[3] === "รวมเป็นเงิน" || item[6] === "ยอดรวมรายการขาย" ? "#f1f1f1" : "#ffffff" },
                        { text: item[2], alignment: item[3] === "รวมเป็นเงิน" || item[6] === "ยอดรวมรายการขาย" ? "center":"right", border, fillColor: item[3] === "รวมเป็นเงิน" || item[6] === "ยอดรวมรายการขาย" ? "#f1f1f1" : "#ffffff" },
                        { text: item[3], alignment: item[3] === "รวมเป็นเงิน" || item[6] === "ยอดรวมรายการขาย" ? "center":"right", border, fillColor: item[3] === "รวมเป็นเงิน" || item[6] === "ยอดรวมรายการขาย" ? "#f1f1f1" : "#ffffff" },
                        { text: item[4], alignment: item[3] === "รวมเป็นเงิน" || item[6] === "ยอดรวมรายการขาย" ? "center":"right", border, fillColor: item[3] === "รวมเป็นเงิน" || item[6] === "ยอดรวมรายการขาย" ? "#f1f1f1" : "#ffffff" },
                        { text: item[5], alignment: item[3] === "รวมเป็นเงิน" || item[6] === "ยอดรวมรายการขาย" ? "center":"right", border, fillColor: item[3] === "รวมเป็นเงิน" || item[6] === "ยอดรวมรายการขาย" ? "#f1f1f1" : "#ffffff" },
                        { text: item[6], alignment: item[3] === "รวมเป็นเงิน" || item[6] === "ยอดรวมรายการขาย" ? "center":"right", border, fillColor: item[3] === "รวมเป็นเงิน" || item[6] === "ยอดรวมรายการขาย" ? "#f1f1f1" : "#ffffff" },
                        { text: item[7], alignment: item[3] === "รวมเป็นเงิน" || item[6] === "ยอดรวมรายการขาย" ? "center":"right", border, fillColor: item[3] === "รวมเป็นเงิน" || item[6] === "ยอดรวมรายการขาย" ? "#f1f1f1" : "#ffffff" },
                      ]}
                    }
                ),
                ],
              },
            };
        reports("รายงานขาย", obj, 12, "portrait");
      }
  render() {
    const {
      modal_detail,
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_payment_type,
      filter_status,
      data,
      count,
      data_warehouse,
      id,
      uid,
      bank_name,
      account_number,
      account_name,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">รายการขาย</h4>
            </div>
            <div className="d-flex align-items-center flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="บิลขาย, ชื่อลูกค้า, เบอร์โทร..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />
              <select
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_payment_type: e.target.value });
                }}
                value={filter_payment_type}
              >
                <option value="">รูปแบบการชำระเงิน</option>
                <option value="ชำระเงินทันที,ชำระมัดจำ">ชำระเงินทันที/ชำระมัดจำ</option>
                <option value="ชำระเงินทันที">ชำระเงินทันที</option>
                <option value="ชำระมัดจำ">ชำระมัดจำ</option>
                <option value="ชำระเงินเชื่อ">ชำระเงินเชื่อ</option>
              </select>
              <select
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_status: e.target.value });
                }}
                value={filter_status}
              >
                <option value="รอชำระ,รอสั่งสินค้า,คืนสินค้า,ใบแจ้งหนี้,เสร็จสิ้น">
                  สถานะ
                </option>
                <option value="รอชำระ">รอชำระ</option>
                <option value="รอสั่งสินค้า">รอสั่งสินค้า</option>
                <option value="ยกเลิก">ยกเลิก</option>
                <option value="คืนสินค้า">คืนสินค้า</option>
              </select>
              <div className="wpx-200 me-2 mb-2">
                <select
                className="form-select wpx-200 me-2 mb-2 mt-2"
                onChange={(e) => {
                  this.setState({ filter_warehouse_id: e.target.value });
                }}
                value={filter_warehouse_id}
              >
                <option value="">
                  ทั้งหมด
                </option>
                {data_warehouse.map(e=>(
                <option value={e.value}>{e.label}</option>
                ))}
              </select>
              </div>
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
              <div className="ms-auto">
                <button className="btn btn-warning px-3 mb-2 me-2" onClick={()=>this.ExportPDF()}>Export PDF</button>
                <DownloadTableExcel
                  filename="รายการขาย"
                  sheet="รายการขาย"
                  currentTableRef={this.tableRef.current}
                >
                  <button className="btn btn-warning px-3 mb-2">Excel</button>
                </DownloadTableExcel>
              </div>
            </div>
            <div className="table-responsive" style={{maxHeight:"70vh"}}>
              <table
                className="table rounded-3 overflow-hidden table-hover"
                ref={this.tableRef}
              >
                <tbody>
                  {data?.filter(item=>!filter_search || JSON.stringify(item?.transaction_list.map(e=>e.product_code + e.product_name)).includes(filter_search)).map((item, index) => (
                    <>
                      <tr>
                        <td className="bg-primary-light text-nowrap"><b>วันที่เอกสาร : </b>
                          {item.created_at? format_date(item.created_at,"dd/mm/yyyy hh:mm น.")
                            : ""}
                        </td>
                        <td className="bg-primary-light text-nowrap"><b>เลขที่เอกสาร : </b>
                          {item.document_no}
                        </td>
                        <td className="bg-primary-light text-nowrap" colSpan={2}><b>ลูกค้า : </b>
                          {item.customer?.full_name || "-"}
                        </td>
                        <td className="bg-primary-light text-nowrap" colSpan={2}><b>คลังสินค้า : </b>
                          {item.warehouse?.name || "-"}
                        </td>
                        <td className="bg-primary-light text-nowrap text-center"><b>รูปแบบการชำระ : </b>
                          {item.payment_type || "-"}
                        </td>
                        <td className="bg-primary-light text-nowrap text-center"><b>สถานะ : </b>
                          {item.status || "-"}
                        </td>
                      </tr>
                      <tr>
                        <td className="fw-bold text-nowrap">ลำดับ</td>
                        <td className="fw-bold text-nowrap">รหัส/ชื่อสินค้า</td>
                        <td className="fw-bold text-nowrap">Serial No.</td>
                        <td className="fw-bold text-nowrap text-end">จำนวน</td>
                        <td className="fw-bold text-nowrap text-end">
                          ราคา/หน่วย
                        </td>
                        <td className="fw-bold text-nowrap text-end">ส่วนลด</td>
                        <td className="fw-bold text-nowrap text-end">
                          ราคาหักส่วนลด
                        </td>
                        <td className="fw-bold text-nowrap text-end">
                          มูลค่ารวม
                        </td>
                      </tr>
                      {item.transaction_list?.map((product, product_index) => (
                        <tr>
                          <td className="text-nowrap">{product_index + 1}</td>
                          <td className="text-nowrap">
                            {" "}
                            {product.product_code} {product.product_name}{" "}
                            {product.remark}
                          </td>
                          <td className="text-nowrap">
                            {product.serial_number || ""}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(product.qty)}
                          </td>
                          <td className="text-nowrap text-end">
                            {" "}
                            {toFixed(product.unit_price)}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(product.discount)}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(
                              Number(product.unit_price) - Number(product.discount)
                            ) || "0.00"}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(
                              Number(product.qty) *
                                (Number(product.unit_price) -
                                  Number(product.discount))
                            ) || "0.00"}
                          </td>
                        </tr>
                      ))}
                       <tr>
                        <td className="bg-light "></td>
                        <td className="bg-light "></td>
                        <td className="bg-light "></td>
                        <td className="bg-light text-nowrap fw-bold">รวมเป็นเงิน</td>
                        <td className="bg-light text-nowrap fw-bold">ส่วนลด</td>
                        <td className="bg-light text-nowrap fw-bold">ราคาหักส่วนลด</td>
                        <td className="bg-light text-nowrap fw-bold">Vat 7%</td>
                        <td className="bg-light text-nowrap fw-bold">รวมทั้งหมด</td>
                      </tr>
                       <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="text-nowrap text-end">{(() => {
                            let total = 0;
                            item.transaction_list?.forEach((p) => {
                              total +=
                                Number(p.qty) *
                                (Number(p.unit_price) -
                                  Number(p.discount));
                            });
                            if (isNaN(total)) total = 0;
                            return `${toFixed(total || 0)}`;
                          })()}</td>
                        <td className="text-nowrap text-end">{toFixed(item.discount)}</td>
                        <td className="text-nowrap text-end">{(() => {
                            let total = 0;
                            item.transaction_list?.forEach((p) => {
                              total +=
                                Number(p.qty) *
                                (Number(p.unit_price) -
                                  Number(p.discount));
                            });
                            if (isNaN(total)) total = 0;
                            return `${toFixed(
                              total - Number(item.discount) || 0
                            )}`;
                          })()}</td>
                        <td className="text-nowrap text-end">{(() => {
                            let total = 0;
                            const vatRate = item.is_vat ? 0.07 : 0;

                            item.transaction_list?.forEach((p) => {
                              const qty = Number(p.qty ?? 0);
                              const unitPrice = Number(p.unit_price ?? 0);
                              const itemDiscount = Number(p.discount ?? 0);
                              total += qty * (unitPrice - itemDiscount);
                            });

                            if (isNaN(total)) total = 0;

                            const billDiscount = Number(item.discount ?? 0); // ส่วนลดทั้งบิล
                            const net = total - billDiscount;

                            const vat = net * vatRate;

                            return `${toFixed(vat)}`;
                          })()}</td>
                        <td className="text-nowrap text-end">{(() => {
                            let total = 0;
                            const vatRate = item.is_vat ? 0.07 : 0;

                            item.transaction_list?.forEach((p) => {
                              const qty = Number(p.qty ?? 0);
                              const unitPrice = Number(p.unit_price ?? 0);
                              const itemDiscount = Number(p.discount ?? 0);
                              total += qty * (unitPrice - itemDiscount);
                            });

                            if (isNaN(total)) total = 0;

                            const billDiscount = Number(item.discount ?? 0); // ส่วนลดทั้งบิล
                            const net = total - billDiscount;

                            const vat = net * vatRate;
                            const grandTotal = net + vat;

                            return `${toFixed(grandTotal)}`;
                          })()}</td>
                      </tr>
                    </>
                  ))}
                   <tr>
                    <td className="bg-secondary-light"></td>
                    <td className="bg-secondary-light"></td>
                    <td className="bg-secondary-light"></td>
                    <td className="bg-secondary-light"></td>
                    <td className="bg-secondary-light">ยอดขายไม่รวม Vat</td>
                    <td className="bg-secondary-light">
                      {(() => {
                        let _data = data?.filter(item=>!filter_search || JSON.stringify(item?.transaction_list.map(e=>e.product_code + e.product_name)).includes(filter_search)) || [];
                        let grandTotal = 0;
                        for(let item of _data){
                            let total = 0;

                            item.transaction_list?.forEach((p) => {
                              const qty = Number(p.qty ?? 0);
                              const unitPrice = Number(p.unit_price ?? 0);
                              const itemDiscount = Number(p.discount ?? 0);
                              total += qty * (unitPrice - itemDiscount);
                            });

                            if (isNaN(total)) total = 0;

                            const billDiscount = Number(item.discount ?? 0); // ส่วนลดทั้งบิล
                            const net = total - billDiscount;

                            grandTotal += net;
                          }

                            return `${toFixed(grandTotal)}`;
                          })()}
                    </td>
                    <td className="bg-secondary-light">ยอดขายรวม Vat</td>
                    <td className="fw-bold text-end bg-secondary-light">
                      {(() => {
                        let _data = data?.filter(item=>!filter_search || JSON.stringify(item?.transaction_list.map(e=>e.product_code + e.product_name)).includes(filter_search)) || [];
                        let grandTotal = 0;
                        for(let item of _data){
                            let total = 0;
                            const vatRate = item.is_vat ? 0.07 : 0;

                            item.transaction_list?.forEach((p) => {
                              const qty = Number(p.qty ?? 0);
                              const unitPrice = Number(p.unit_price ?? 0);
                              const itemDiscount = Number(p.discount ?? 0);
                              total += qty * (unitPrice - itemDiscount);
                            });

                            if (isNaN(total)) total = 0;

                            const billDiscount = Number(item.discount ?? 0); // ส่วนลดทั้งบิล
                            const net = total - billDiscount;

                            const vat = net * vatRate;
                            grandTotal += net + vat;
                          }

                            return `${toFixed(grandTotal)}`;
                          })()}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
